import { StatusBadge } from "../../../Components/ui/statusBadge";

export function renderStatus(status: string) {
  switch (status) {
    case "open":
      return <StatusBadge variant="warning" labelKey={"open"}/>;
    case "in-shop":
      return <StatusBadge variant="warning" labelKey={"inShop"}/>;
    case "inspection":
      return <StatusBadge variant="negative" labelKey={"inspection"}/>;
    case "in-progress":
      return <StatusBadge variant="negative" labelKey={"inProgress"}/>;
    case "waiting-parts":
      return <StatusBadge variant="negative" labelKey={"waitingParts"}/>;
    case "tasks-completed":
      return <StatusBadge variant="positive" labelKey={"tasksCompleted"}/>;
    case "completed":
      return <StatusBadge variant="positive" labelKey={"completed"}/>;
    case "closed":
      return <StatusBadge variant="positive" labelKey={"closed"}/>;
    case "pending":
      return <StatusBadge variant="warning" labelKey={"pending"}/>;
    default:
      return "";
  }
}

export function renderPriorityStatus(priority: string) {
  switch (priority) {
    case "1":
      return <StatusBadge variant="critical" labelKey={"urgent"}/>;
    case "2":
      return <StatusBadge variant="negative" labelKey={"important"}/>;
    case "3":
      return <StatusBadge variant="positive" labelKey={"normal"}/>;
    default:
      return "";
  }
}